import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledShowThumbnailsSidebarButton } from './show-thumbnails-sidebar-button.styles';

const ShowThumbnailsSidebarButton = () => {
  const [state, dispatch] = useContext(Context);
  const handleClick = () => {
    dispatch({ type: 'TOGGLE_THUMBNAILS_SIDEBAR' });
  };

  return (
    <StyledShowThumbnailsSidebarButton
      data-ignore-click-outside="sidebar"
      onClick={handleClick}
      isActive={state.isThumbnailsSidebarOpened}
    >
      Эскизы страниц
    </StyledShowThumbnailsSidebarButton>
  );
};

export default ShowThumbnailsSidebarButton;
